import { Page } from '@/components/layout/Page';
import { CreateScenarioForm } from '@/features/decisions/components/backtests/CreateScenarioForm';
import { SubmitRunForm } from '@/features/decisions/components/backtests/SubmitRunForm';

export function Execute() {
  return (
    <Page>
      <div className="flex flex-col gap-6">
        <CreateScenarioForm />
        <SubmitRunForm />
      </div>
    </Page>
  );
}
